import { Record } from 'immutable';

/**
 * This record stores listings data consumed by ListViewer.
 * It automates setting/unsetting the inflight status of the data.
 *
 * @param {[Listing]} data The listings data
 * @param {boolean} inFlight Flag that tells if data is being fetched
 */
export class ListingDataRec extends Record({
  data: null,
  inFlight: false,
}) {
  setInFlight() {
    return this.set('inFlight', true);
  }

  setData(listingData) {
    return this.merge({ data: listingData, inFlight: false });
  }
}
